module.exports = __webpack_public_path__ + "static/media/store-alt.37d4d331.svg";